import React, { useEffect, useState } from "react"
import { findLogosForAllDomains } from "~Shared/utils/logo.utils"

interface LogoFinderProps {
    name: string
    fallback: React.ReactNode
}

const LogoFinder = ({ name, fallback }: LogoFinderProps) => {
    const [logo, setLogo] = useState<string | undefined>(undefined)

    const fetchLogoLink = async (abortController: AbortController) => {
        try {
            const foundImages = await findLogosForAllDomains({ searchString: name, abortController })
            if (foundImages.length > 0) {
                setLogo(foundImages[0])
            }
        } catch {
            // ignore error
        }
    }

    useEffect(() => {
        const abortController = new AbortController()

        fetchLogoLink(abortController)

        return () => {
            abortController.abort()
        }
    }, [])

    return (
        <div className="w-full h-full max-w-50 max-h-50 border justify-center align-center self-center items-center mr-10 p-2 rounded-lg">
            {logo && logo.length ? (
                <img className="w-full h-auto max-w-50 max-h-50  flex justify-center items-center" src={logo} alt="logo" />
            ) : (
                <span className="placeholder-primary text-xl h-44 max-w-50 flex justify-center items-center">{fallback}</span>
            )}
        </div>
    )
}

export const LogoFinderMemo = React.memo(LogoFinder)
